import { Check, Heart, Star } from 'lucide-react'

import ErrorBoundary from '@/components/ErrorBoundary'

import logo from '../../logo-white-no-bg.svg'

export default function AuthLayout({ info, children }) {
    return (
        <main className='min-h-dvh bg-gradient-to-br from-cyan-400 via-cyan-500 to-cyan-600 relative'>
            <div className='absolute inset-0 overflow-hidden'>
                <div className='absolute  animate-pulse  hidden sm:block top-20 right-32 w-32 h-32 bg-secondary-300/10 rounded-lg rotate-12 animate-float'></div>
                <div className='absolute  animate-pulse  hidden sm:block  top-64 left-20 w-24 h-24 bg-secondary-400/25 rounded-lg -rotate-6 animate-float-delayed'></div>
                <div className='absolute  animate-pulse  hidden sm:block  bottom-32 right-40 w-40 h-40 bg-secondary-300/20 rounded-xl rotate-45 animate-float-slow'></div>
                <div className='absolute  animate-pulse  hidden sm:block  bottom-48 left-1/3 w-28 h-28 bg-brand-400/35 rounded-lg -rotate-12 animate-float'></div>

                <div className='absolute  animate-pulse  hidden sm:block  top-1/3 right-20 w-16 h-16 bg-brand-200/40 rounded-md rotate-45 animate-float-delayed'></div>
                <div className='absolute  animate-pulse  hidden sm:block  top-1/2 left-16 w-20 h-20 bg-brand-300/30 rounded-lg -rotate-12 animate-float-slow'></div>
                <div className='absolute  animate-pulse  hidden sm:block  bottom-20 left-1/2 w-18 h-18 bg-brand-300/35 rounded-md rotate-30 animate-float'></div>

                <div className='absolute  animate-pulse  hidden sm:block top-40 left-1/4 w-12 h-12 bg-secondary-100/50 rounded rotate-45 animate-float-slow'></div>
                <div className='absolute  animate-pulse  hidden sm:block top-3/4 right-1/4 w-14 h-14 bg-secondary-200/40 rounded-md -rotate-30 animate-float-delayed'></div>
                <div className='absolute  animate-pulse  hidden sm:block bottom-40 right-1/3 w-10 h-10 bg-secondary-200/45 rounded rotate-12 animate-float'></div>
            </div>

            <div className='relative z-10 flex min-h-screen'>
                <div className='hidden lg:flex lg:flex-1 flex-col justify-center px-12 py-16'>
                    <div className='max-w-lg mx-auto'>
                        <img src={logo} className='w-96 mb-8 animate-jump-in' />

                        <div className='text-white mb-12'>
                            <p className='text-xl text-white/90 leading-relaxed mb-8'>
                                Empowering families with personalized support for every step of your child's
                                developmental journey.
                            </p>
                        </div>
                    </div>
                </div>

                <div className='flex-1 flex flex-col justify-center px-6 py-16 lg:px-12'>
                    <div className='w-full max-w-md mx-auto'>
                        <div className='lg:hidden mb-12 text-center'>
                            <img src={logo} className='h-28 mx-auto relative z-10 mt-2' />
                            <p className='text-white/90 text-md w-72 mx-auto text-wrap'>
                                Supporting your child's developmental journey
                            </p>
                        </div>

                        <div className='bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 p-8 lg:p-10 hover:shadow-3xl transition-all duration-300'>
                            <ErrorBoundary componentName='Auth'>{children}</ErrorBoundary>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
